import React from 'react'
import './Settings.css'
import { Link } from 'react-router-dom'

const Settings = () => (
  <div className='settings'>
    <h2 className='settings__title'>Tu cuenta</h2>
    <Link to='/account' className='settings__option'>Configuración de cuenta</Link>
    <h2 className='settings__title'>Ayuda</h2>
    <Link to='/rules' className='settings__option'>Reglas</Link>
    <Link to='/faq' className='settings__option'>Preguntas frecuentes</Link>
    <h2 className='settings__title'>Nosotros</h2>
    <Link to='/about' className='settings__option'>Acerca de</Link>
    <Link to='/contact' className='settings__option'>Contáctanos</Link>
  </div>
)

export default Settings
